<div #buttonsContainer>
  <ng-template mapTopBarButtonsItemHost></ng-template>
</div>
